import { isOfType } from 'common/helpers'
import type { IdOf } from 'common/types'

export const logLevels = ['log', 'warn', 'error'] as const

export type LogLevel = (typeof logLevels)[number]

export type LogMessage = {
  text: string
  logLevel: LogLevel
}

const httpRequestTypes = [
  'GET',
  'HEAD',
  'POST',
  'PUT',
  'DELETE',
  'CONNECT',
  'OPTIONS',
  'PATCH',
] as const

type HttpRequestType = (typeof httpRequestTypes)[number]

export const isHttpRequestType = isOfType(httpRequestTypes)

type CorrelationId = IdOf<'correlation'>

export type HttpRequestLog = {
  httpRequestType: HttpRequestType
  sizeInBytes: number
  url: string
  status: number
  date: string
  correlationId: CorrelationId
}
